export default (value) => {
  const pattern = /^\d{2}\/\d{2}\/\d{4}$/;

  if (!pattern.test(value)) {
    return false;
  }

  const [day, month, year] = value
    .split('/')
    .map((piece) => parseInt(piece, 10));
  const date = new Date(year, month - 1, day);

  // Fixed from https://esganzerla.medium.com/simple-date-validation-with-javascript-caea0f71883c
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};
